var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.isMobileScreen ? '' : 'ylAboutAdvantages',attrs:{"id":"ylAboutAdvantages"}},[(_vm.isMobileScreen)?_c('ylAboutAdvantagesMobile',_vm._b({attrs:{"list":_vm.list}},'ylAboutAdvantagesMobile',_vm.$attrs,false)):_c('ylAboutAdvantagesPC',_vm._b({attrs:{"list":_vm.list}},'ylAboutAdvantagesPC',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }